import { applicationInsights } from './applicationInsights';

/**
 * Usage events for the Scout Central home page, so the post-implementation review can tell which
 * entry points people actually use (CR12940-PIV-013). Before these, a conversation started from the
 * home page looked the same in telemetry whichever control started it.
 *
 * Properties carry identifiers and positions only — never the text of a question — and App Insights
 * already attaches the user and session to every event.
 */
export type HomeEvent =
  | { name: 'HomeSearchSubmitted'; properties: { routing: 'scout' | 'mention'; agentId: string } }
  | { name: 'HomeSuggestionClicked'; properties: { agentId: string; position: number } }
  | { name: 'HomeAgentCardClicked'; properties: { agentId: string; category: string; badge: 'new' | 'updated' | 'none'; position: number } }
  | { name: 'HomeRecentConversationOpened'; properties: { agentName: string; position: number } }
  | { name: 'HomeWhatsNewClicked'; properties: { agentId: string; version: string; position: number } };

export function trackHomeEvent(event: HomeEvent): void {
  try {
    applicationInsights.trackEvent(event.name, event.properties);
  } catch {
    // Telemetry must never get in the way of starting a conversation.
  }
}
